import React from "react"
import { RegisterScreenNavigationProps } from "./types"
import Register from "./register-screen"
import { PageRoot } from "~screens/page-root"

const RegisterScreen: React.FC<RegisterScreenNavigationProps> = () => {
  return (
    <PageRoot $background="#fff">
      <Register />
    </PageRoot>
  )
}

export default RegisterScreen
